/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-no-bind */
import React from 'react';

import Image1 from './../../img/1.png';
import Image2 from './../../img/2.png';
import Image3 from './../../img/3.png';
import Image4 from './../../img/4.png';
import Image5 from './../../img/5.png';
import Image6 from './../../img/6.png';
import Image7 from './../../img/7.png';

const imgUrls = [
	{
		id: 1,
		src: Image1,
		notes: ''
	},
	{
		id: 2,
		src: Image2,
		notes: ''
	},
	{
		id: 3,
		src: Image3,
		notes: ''
	},
	{
		id: 4,
		src: Image4,
		notes: ''
	},
	{
		id: 5,
		src: Image5,
		notes: `1. After you update the fields, you need to expand the collection and select the Login (Client Assertion). Then click on send and you'll be logged in.`
	},
	{
		id: 6,
		src: Image6,
		notes: '2. After the login this is how the response should look like.'
	},
	{
		id: 7,
		src: Image7,
		notes: `3. Then you're ready to make any request from the collection.	`
	}
];

export default class Instructions extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedPage: 0
		};
	}

	handlePageSelection = (id) => {
		this.setState({ selectedPage: id });
	};

	render() {
		const { selectedPage } = this.state;
		const { getComponent } = this.props;

		const Link = getComponent('Link');

		const steps = [
			{
				title: 'Obtain the CA Signed Certificate from CA Authority',
				id: 0,
				content: () => {
					return (
						<div className="w-100 h-100">
							<h5 className="p-3 text-muted">
								<b>1. Generate private key and the CSR file on your machine</b>
							</h5>
							<p className="py-1s">
								A <b>CSR</b> (Certificate Signing Request) is an encoded file that provides you with a
								standardized way to send your public key as well as some information that identifies
								your company and domain name.
							</p>
							<p className="py-1">
								Run in terminal: <b>openssl req -newkey rsa:2048 -keyout PRIVATEKEY.key -out MYCSR.csr</b>
							</p>
							<ul>
								<li className="py-1">
									<b>openssl</b> is the command for running OpenSSL
								</li>
								<li className="py-1">
									<b>req</b> is the OpenSSL utility for generating a CSR
								</li>
								<li className="py-1">
									<b>-newkey rsa:2048</b> tells OpenSSL to generate a new 2048-bit RSA private key. If
									you would prefer a 4096-bit key, you can change this number to 4096.
								</li>
								<li className="py-1">
									<b>-keyout PRIVATEKEY.key</b> specifies where to save the private key file.
								</li>
								<li className="py-1">
									<b>-out MYCSR.csr</b> specifies where to save the CSR file.
								</li>
							</ul>

							<h5 className="p-3 text-muted">
								<b>2. Send public key to CA Authority</b>
							</h5>

							<p className="py-1">
								Second step is to send the CSR file to one of the
								<a href="https://en.wikipedia.org/wiki/Certificate_authority" target="_blank">
									{` CA `}
								</a>{' '}
								Approved issuers:
							</p>
							<ul>
								<li className="py-1">DigiCert (recommended)</li>
								<li className="py-1">GoDaddy (recommended)</li>
								<li className="py-1">IdenTrust (recommended)</li>
								<li className="py-1">GlobalSign</li>
								<li className="py-1">Sectigo</li>
								<li className="py-1">Certum</li>
							</ul>

							<h5 className="p-3 text-muted">
								<b>3. Get signed certificate</b>
							</h5>
							<p className="py-1">After you get the response with the certificate file from the CA Authority, send it to Toyota.</p>
						</div>
					);
				}
			},
			{
				title: 'Obtain Azure AD credentials',
				id: 1,
				content: () => {
					return (
						<div className="w-100 h-100">
							<p className="py-1">You will receive from Toyota the following parameters:</p>
							<ul>
								<li className="py-1">service endpoint</li>
								<li className="py-1">tenant</li>
								<li className="py-1">client_id</li>
								<li className="py-1">x5t</li>
								<li className="py-1">qa resource server </li>
								<li className="py-1">prod resource server</li>
							</ul>
							<p className="py-1">You'll need them to login and access the DDOA REST JSON Services API.</p>
						</div>
					);
				}
			},
			{
				title: 'Login and access the DDOA DS APIs',
				id: 2,
				content: () => {
					return (
						<div className="w-100 h-100">
							<p className="pt-2">
								In order to access the DDOA REST JSON Services API, you need to login and generate the
								assertion token.
							</p>
							<p className="pb-1">
								Download the Postman files and open the app.
							</p>
							<Link target="_blank" href={`/collections/toyota-ddoa-postman.zip`}>
								<button className="btn btn-primary">Download</button>
							</Link>

							<div className="w-100 h-100 d-flex flex-column">
								{imgUrls.map((img) => (
									<div className="w-100 h-100 my-2">
										<h5 className="my-3 px-2">{img.notes}</h5>
										<img key={img.id} src={img.src} alt={`Img-${img.id}`} />
									</div>
								))}
							</div>
						</div>
					);
				}
			},
			{
				title: 'DSP Integration Security Specification',
				id: 3,
				content: () => {
					return (
						<div className="w-100 h-100">
							If you want to see more details about the DSP Integration Security Specification for REST JSON Services click {' '}
							<a href="/docs/Toyota_DDOA_DSP_REST_Integration_Security_Specification.pdf" target="_blank">
								here.
							</a>
						</div>
					);
				}
			}
		];

		return (
			<div className="bootstrap-scope h-100">
				<div className="instructions-container w-100 px-5  mt-5">
					<div className="w-100 h-90 d-flex align-items-center position-relative">
						<ul className="w-30 secondary-content list-group">
							{steps.map((d) => {
								return (
									<li
										key={d.title}
										onClick={() => this.handlePageSelection(d.id)}
										className={`w-100 cursor-pointer list-group-item ${selectedPage === d.id
											? 'active'
											: ''}`}
									>
										{d.id + 1}. {d.title}
									</li>
								);
							})}
						</ul>
						<div className="main-content border">
							<div className="w-100 py-5 h-100 bg-white">
								<h4 className="px-5 py-2 my-0">
									{selectedPage + 1}. {steps[selectedPage].title}
								</h4>
								<div className="w-100 h-100 px-5">{steps[selectedPage].content()}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
